module.exports = __webpack_public_path__ + "img/vibirajte.e5321f34.png";